import React from 'react';

import { useSelectorHasAuth } from '../../../auth';
import { useSelectorActiveSession } from '../../../session/session.selectors';
import {
    useSelectorHasCurrentProductAccess, useSelectorIsProfileLoaded
} from '../../../user-profiles';
import { useSelectorIsInitialized } from '../../state';
import { LicenceOverlayContainer } from './components/licence-overlay-container/licence-overlay-container';
import { ContentOverlayBackground } from './product-licence-manager.styled';

/**
 * Main component for handling user access to the product. There are scenarios
 * where the user must be locked out from using the product.
 * The main business rules for this are in the utility hasProductLicenceAccess().
 * The attribute data-has-access is used for testing the current access state.
 */
export function ProductLicenceManager () {
    const hasAccess = useSelectorHasCurrentProductAccess();
    const isApplicationReady = useIsReadyForLicenceLock();

    // Add a helper dom element with the attribute data-has-access for testing.
    return (
        <div
            data-testid={'product-licence-manager'}
            data-has-access={hasAccess}
        >
            {!hasAccess && isApplicationReady ? <ContentOverlayBackground>
                <LicenceOverlayContainer />
            </ContentOverlayBackground> : null}
        </div>
    );
}

/**
 * Only evaluate the licence checking when the app is ready.
 */
function useIsReadyForLicenceLock () {
    const isInitialized = useSelectorIsInitialized();
    const isLoggedIn = useSelectorHasAuth();
    const isSessionActive = useSelectorActiveSession();
    const profileLoaded = useSelectorIsProfileLoaded();

    return (
        isInitialized &&
        isLoggedIn &&
        isSessionActive &&
        profileLoaded
    );
}
